/**
 * A frase de um erro que pode ir para a tela. Erro criado pelo próprio app
 * (texto nosso, em português) passa; erro de biblioteca, de rede ou do
 * servidor do mensageiro (código, endereço, nome técnico) vira a frase de
 * reserva. O detalhe técnico nunca aparece para a pessoa.
 */
export function friendlyError(error: unknown, fallback: string): string {
  if (!(error instanceof Error) || !error.message) return fallback;
  const technical =
    error.name !== 'Error' ||
    /M_[A-Z]|https?:\/\/|\[\d{3}\]|\bfetch\b|\bnetwork\b|undefined|null|JSON|token/i.test(
      error.message,
    );
  return technical ? fallback : error.message;
}
